import React from "react";
import EnrichedTrackingView from "../EnrichedTrackingView";

const EnrichedBagDetailsUI = ({ endpoint, awbNumber, showBackArrow }) => (
  <EnrichedTrackingView
    endpoint={endpoint}
    awbNumber={awbNumber}
    showBackArrow={showBackArrow}
  />
);

export default EnrichedBagDetailsUI;
